import { TideClientConfig } from "..";

import {
  PackagingAccommodationRequest,
  PackagingAccommodationResponse,
  PackagingEntry,
} from "../types";
import { get, post } from "./common-client";

const ENDPOINT = "/api/web/packaging";
const ENDPOINT_ACCOMMODATIONS = `${ENDPOINT}/accommodations`;
const ENDPOINT_ENTRY = (magicLinkCode: string) =>
  `${ENDPOINT}/entry/${magicLinkCode}`;

// MANUAL PACKAGING SEARCH

export const searchPackagingAccommodations = (
  config: TideClientConfig,
  request: PackagingAccommodationRequest,
  signal?: AbortSignal
): Promise<PackagingAccommodationResponse[]> => {
  const url = `${config.host}${ENDPOINT_ACCOMMODATIONS}`;
  const apiKey = config.apiKey;
  const body = JSON.stringify(request);

  return post(url, apiKey, body, config.token, signal, true);
};

export const getEntry = (
  config: TideClientConfig,
  magicLinkCode: string,
  signal?: AbortSignal
): Promise<PackagingEntry> => {
  const apiKey = config.apiKey;

  const url = `${config.host}${ENDPOINT_ENTRY(magicLinkCode)}`;

  return get(url, apiKey, config.token, signal, true);
};
